<template>
  <div class="animated fadeIn">
    <h2>Pagina personale di {{nome}}</h2>
    <!--
    <h2>DPCM 8 marzo 2020</h2><br><br>
    <h3>Attività formativa e stage sospesi fino al 3 aprile</h3>
    <h4 v-if="!getTokenData().sub.guest || getTokenData().sub.guest.sedeid!=1">Seguiranno indicazioni per la formazione a distanza</h4>
    <h4 v-else><a href="https://swone.ecfop.it/LIM/2019-20/FAD-IO%20RESTO%20A%20CASA.pdf" target="_blank">Scarica le istruzioni per la formazione a distanza</a></h4>
    -->
    <b-row class="mt-4 justify-content-center">
      <b-col
        v-for="item in menuVoci"
        :key="item.url"
        cols="6" sm="4" md="3" lg="2"
        class="mb-4 text-center"
      >
        <div class="dash-icon-card" @click="$router.push('/' + item.url)">
          <div style="position: relative; display: inline-block;">
            <i :class="item.icon + ' dash-icon-placeholder'"></i>
            <span v-if="messaggi && item.name === 'Avvisi'" class="dash-badge">!</span>
          </div>
          <div class="dash-icon-label">{{ item.name }}</div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { API } from "@/api.js";

export default {
  name: "dashboard",
  mixins: [window.myMixin],
  components: {},
  data: function() {
    return {
      check: false,
      messaggi: false,
      menuVoci: [],
    };
  },
  computed: {
    nome() {
      return this.getUserName();
    },
  },
  beforeDestroy(){
    this.check = false
  },
  methods: {
    async verifica(){
      var url = new URL(window.location.href);
      let cid = this.getCorsID();
      if (cid) {
        let msgs = await API.sqlprep(this, "messaggi.get", [cid]);
        this.messaggi = msgs.data.dati.length
      }
      if(this.check)
        setTimeout(this.verifica, 1000*3600) // ogni ora
    }
  },
  mounted: async function() {
    this.check = true
    this.verifica()
    let menu = await API.getmenu(this, 0, 0)
    // TODO: voce provvisoria — rimuovere quando "Selfie" sarà inserita nella tabella menu del DB
    // Visibile solo ai corsisti di prima annualità (e solo per ECFOP)
    var tdSelfie = this.getTokenData()
    if (window.ECFOP && tdSelfie && tdSelfie.sub && tdSelfie.sub.guest && tdSelfie.sub.guest.annualita == 1)
      menu.push({ icon: "fa fa-camera", name: "Selfie", url: "selfie" })
    this.menuVoci = menu.filter(item => item.url && item.url !== 'dashboard')
  }
};
</script>

<style scoped>
.dash-icon-card {
  cursor: pointer;
  padding: 20px 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  transition: background-color 0.2s, box-shadow 0.2s;
}
.dash-icon-card:hover {
  background-color: #f0f4ff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}
.dash-icon-placeholder {
  font-size: 3rem;
  color: #6c757d;
  display: block;
  margin-bottom: 8px;
}
.dash-icon-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
}
.dash-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #dc3545;
  color: white;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: bold;
  border: 2px solid white;
}
</style>
